import React from 'react';
import { Newspaper } from 'lucide-react';

const FeaturedIn = () => {
  const publications = [
    {
      name: "NYC Local News",
      type: "Featured Article",
      year: "2024"
    },
    {
      name: "Pest Control Today",
      type: "Industry Feature",
      year: "2024"
    },
    {
      name: "Green Business Journal",
      type: "Eco-Friendly Spotlight",
      year: "2024"
    },
    {
      name: "NY Small Business Guide",
      type: "Local Business Profile",
      year: "2024"
    }
  ];

  return (
    <section className="py-16" style={{ background: 'var(--bg-section)' }}>
      <div className="container">
        <div className="text-center mb-10">
          <h2 className="heading-2 mb-3">As Featured In</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Recognized by industry leaders and local media
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {publications.map((pub, index) => (
            <div 
              key={index}
              className="product-card text-center"
            >
              <div 
                className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center"
                style={{ background: 'var(--accent-wash)' }}
              >
                <Newspaper size={28} style={{ color: 'var(--accent-text)' }} />
              </div>
              <h3 
                className="heading-3 mb-2"
                style={{ fontSize: '1rem' }}
              >
                {pub.name}
              </h3>
              <p className="body-small mb-1" style={{ color: 'var(--text-secondary)' }}>
                {pub.type}
              </p>
              <p className="caption" style={{ color: 'var(--text-muted)' }}>
                {pub.year}
              </p>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-8">
          <p className="body-small" style={{ color: 'var(--text-muted)' }}>
            Building partnerships with local and industry publications
          </p>
        </div>
      </div>
    </section>
  );
};

export default FeaturedIn;
